 <!--Full width header Start-->
<div class="full-width-header header-style1 home8-style4">
  <main-menu></main-menu>
</div>
<!--Full width header End-->
<!-- Main content Start -->
<div class="main-content">
  <!-- Breadcrumbs Start -->
  <div class="rs-breadcrumbs breadcrumbs-overlay">
    <div class="breadcrumbs-img">
      <img src="assets/images/breadcrumbs/2.jpg" alt="Breadcrumbs Image">
    </div>
    <div class="breadcrumbs-text white-color">
      <h1 class="page-title">{{ profile()?.name || 'Balaji Insurance' }}</h1>
      <ul>
        <li><a class="active" [routerLink]="['/']">Home</a></li>
        <li><a>About</a></li>
        <li>{{ profile()?.name || 'Balaji Insurance' }}</li>
      </ul>
    </div>
  </div>
  <!-- Breadcrumbs End -->
  <!-- Blog Section Start -->
  <div *ngIf="profile()" class="rs-inner-blog orange-color pt-100 pb-100 md-pt-70 md-pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-12 pr-50 md-pr-15">
          <about-menu></about-menu>
        </div>
        <div class="col-lg-8">
          <section class="profile-section orange-color">
            <div class="container">
              <div class="row clearfix">
                <!-- Image Section -->
                <div class="image-column col-lg-5 md-mb-50">
                  <div class="inner-column mb-50 md-mb-0">
                    <div class="image">
                      <img [src]="profile()?.profileImage" [alt]="profile()?.name || ''" class="img-fluid" />
                    </div>
                    <div class="team-content text-center">
                      <h3>{{ profile()?.name }}</h3>
                      <div class="text">{{ profile()?.designation }}</div>
                    </div>
                  </div>
                </div>
                <!-- Content Section -->
                <div class="content-column col-lg-7 md-pl-15 md-pt-0">
                  <div class="inner-column">
                    <h2>{{ profile()?.name }}</h2>
                    <h4>{{ profile()?.designation }}</h4>
                    <p *ngFor="let description of profile()?.descriptions | slice:0:2">
                      {{ description }}
                    </p>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="content-column">
                    <div class="inner-column row" *ngFor="let description of profile()?.descriptions | slice:2">
                      <p [innerHTML]="description"></p>
                    </div>
                    <div class="inner-column row" *ngFor="let desc of profile()?.additionalDescriptions">
                      <p [innerHTML]="desc"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>          
        </div>
      </div>
    </div>
  </div>
  <!-- Blog Section End -->
  <!-- Newsletter section start -->
  <app-subscribe></app-subscribe>
  <!-- Newsletter section end -->
</div>
<!-- Main content End -->
